import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IWebhooksPanelButtonProps } from './types';
import { WEBHOOKS_SECTION_TITLE } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function WebhooksPanelButton ({
    isShow,
    onClick
}: IWebhooksPanelButtonProps) {
    if (!isShow) return null;
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.WEBHOOKS}
            title={WEBHOOKS_SECTION_TITLE}
            onClick={() => {
                setSubTab(EBoardSetting.WEBHOOKS);
                onClick();
            }}
        />
    );
}
